
<template> 
    <div class="row"  > 
        <div class="col-12 col-sm-12 col-md-12"> 
            <CardRh :processando="processando"  >   
                <div class="row" >  
                    <div class="col-12 col-sm-12 col-lg-4"> 
                        <div class="form-group">  
                            <label for="arquivo" class="form-label">Arquivo</label>
                            <input type="file" id="arquivo" ref="arquivoReferencia" name="arquivo" class="form-control" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" v-on:change="handleFileUpload()">  
                        </div>
                    </div>  
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                        <div class="mb-2">
                            <label for="publicacao" class="form-label">Classe SGPM</label>
                            <input type="text" v-model="classeSgpm" class="form-control form-control-solid" placeholder="Classe SGPM"/>
                        </div> 
                    </div>  
                    <div class="col-12 col-sm-12 col-lg-2"> 
                        <button type="button" class="btn btn-pmes-secondary me-10 mt-8"  @click="salvar" :data-kt-indicator=" processando ? 'on' : 'off' ">
                            <span class="indicator-label">Inserir Sgpm</span>
                            <span class="indicator-progress">Processando<span
                                class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </div>  
                <br> 
            </CardRh>   
        </div>  
    </div>
    <br> 
    <hr>
    <br> 
</template>

<script lang="ts">
     
    import { Options, Vue } from "vue-class-component";   
    import { ref } from 'vue';
    import PatrimonioService from   "@/service/v1/sigap/PatrimonioService"  
    import CardRh from   "@/components/cards/ManzaCard.vue"
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "FileSiga",
        components: {   CardRh },  
        emits: ['sgpm-lote-cadastro'],   
    }) 
    export default class FileSiga extends Vue { 

        @authStore.Getter
		public perfis!: any  
 
        public service = new PatrimonioService();  
 
        private arquivoReferencia = ref<FileList | null>(null);
        public arquivo: any = ''; 
        public classeSgpm: any = ''; 
        public processando = false;
         
        handleFileUpload() {  
            this.arquivo =  ( this.arquivoReferencia as any ).files![0]; 
        }
 
        public salvar() {   
            if (this.arquivo  && this.classeSgpm ) {
                this.processando = true;
                const dados = new FormData(); 
                dados.append('File', this.arquivo); 
                dados.append('ClasseSgpm', this.classeSgpm); 
                this.service.ProccesaPatrimonioSGPMLote(   dados  )
                .then(response => {
                    this.$emit("sgpm-lote-cadastro", null);   
                    this.processando = false; 
                })
                .catch(error => {  
                    this.processando = false; 
                    console.log(error);
                })
                .finally( () => {
                    this.processando = false;
                });   
            }  
        } 
 
 
    }
</script>
 